import { EventTypes, IReducerPayload, IAuthReducer } from '../dataModels';
import { IReduxAction } from '@core-web/redux';

const initialState = {
  isAuthenticated: false,
};

export const Reducer = (
  state: IAuthReducer = initialState,
  { type, payload }: IReduxAction<EventTypes, IReducerPayload>
): IReducerPayload => {
  switch (type) {
    case EventTypes.AUTHENTICATED: {
      return { ...state, ...payload };
    }
    case EventTypes.VERIFIED: {
      return { ...state, ...payload, isAuthenticated: true };
    }
    case EventTypes.LOGOUT: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
